import { combineReducers } from 'redux';
import user from './user';
import event from './event';
import collections from './collections';
import formCollections from './formCollections';
import events from './events';
import extraFieldsCollections from './extraFieldsCollections';

const reducers = combineReducers({
  user,
  event,
  collections,
  formCollections,
  events,
  extraFieldsCollections,
});

export default reducers;
